<template>
	<div class="tabWrapperSettings tabCompanies">
		<main-table
				padding="0"
				:flag="flag"
				:headers="getHeaders"
				:listItems="companiesCompanies"
				@updateClickButton="onClickButton($event, flag)"
				:items-per-page-amount="10"
				:pages="[ 10, 20, 50, 100, 200, 500, 'All' ]"
				@updateCreate="onCreate"
				text-create="Add new company"
				page-title="Company"
				:is-filter-refresh="false"
				:is-export="false"
				:is-search="false"
				:is-create="isCreate()"
		></main-table>

		<view-companies
				v-if="isViewCompanies"
				:dialogFlag="dialogFlag"
				:editCompanies="editCompanies"
				@updateClose="onCloseDialog('isViewCompanies')"
				@updateList="onUpdateList('companies')"
		></view-companies>

		<dialog-remove
				v-if="isDialogRemove"
				:titleRemove="titleRemove"
				:textRemove="textRemove"
				@updateRemove="onRemove"
				@updateCloseRemove="onCloseRemove"
		></dialog-remove>
	</div>
</template>

<script>
import MainTable from "@/shared/MainTable/MainTable.vue";
import { tabCompaniesTable, TEXT, TITLE } from "@/pages/Settings/UserAccountSettings/constants";
import ViewCompanies from "@/components/Settings/UserAccountSettings/ViewCompanies/ViewCompanies";
import DialogRemove from "@/shared/DialogRemove/DialogRemove.vue";

import { mapActions, mapGetters } from "vuex";
import { PERMISSIONS, TAB } from "@/constants/constants";
import { getPermissionsMod } from "@/helper/getPermissionsMod";

export default {
	name: "tabCompanies",
	components: {
		DialogRemove,
		ViewCompanies,
		MainTable
	},
	computed: {
		...mapGetters([
			'editCompanies',
			'settingsCompanies',
			'companiesCompanies',
			'filtersCompanies',
			'permissionsDefault',
		]),
		getHeaders() {
			return tabCompaniesTable;
		},
	},

	data: () => ({
		flag: TAB.COMPANIES,

		isViewCompanies: false,
		dialogFlag: null,
		nameComponent: null,
		isDialogRemove: false,
		titleRemove: null,
		textRemove: null,
		activeItem: null,
	}),

	methods: {
		...mapActions([
			'getAccountCompaniesList',
			'getAccountCompaniesEdit',
			'deleteAccountCompanies',
		]),

		isCreate() {
			const list = this.permissionsDefault;
			const path = [ PERMISSIONS.SETTINGS, PERMISSIONS.USER_ACCOUNT_SETTINGS, PERMISSIONS.U_A_S_COMPANY, PERMISSIONS.CREATE ];
			return getPermissionsMod({ list, path });
		},
		async onUpdateList(key) {
			if (key === 'companies') {
				await this.getAccountCompaniesList();
			}
		},

		onClickButton({ key, item }, nameComponent) {
			this.dialogFlag = 'edit';
			this.nameComponent = nameComponent;
			this.activeItem = item;

			if (nameComponent === 'tabCompanies' && key === 'edit1') {
				this.accountCompaniesEdit();
			}
			if (nameComponent === 'tabCompanies' && key === 'delete1') {
				const title = TITLE.REMOVE_DOCUMENTS_TYPES;
				const text = TEXT.REMOVE_DOCUMENTS_TYPES;
				this.onRemoveDialog({ title, text });
			}
		},
		async onRemove() {
			if (this.nameComponent === 'tabCompanies') {
				const { id } = this.activeItem;
				await this.deleteAccountCompanies(id);
				this.onCloseRemove();
			}
		},
		onRemoveDialog(args) {
			const { title, text } = args;
			this.titleRemove = title;
			this.textRemove = text;
			this.isDialogRemove = true;
		},
		onCloseRemove() {
			this.isDialogRemove = false;
		},
		async accountCompaniesEdit() {
			const { id } = this.activeItem;
			await this.getAccountCompaniesEdit(id);
			this.isViewCompanies = true;
		},
		onCreate() {
			this.dialogFlag = 'add';
			this.isViewCompanies = true;
		},
		onCloseDialog(key) {
			this[key] = false;
		},
	},
	async mounted() {
		await this.getAccountCompaniesList();
	}
};
</script>

<style scoped lang="scss">
@import "tabWrapperSettings";
</style>

